<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Administradores | Edição" />
    <v-row justify="center" align="center">
      <v-col>
        <form-admin
          v-if="model"
          v-model="model"
          :readonly="false"
          :editing="true"
          @submit="submit"
        />
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import AdminService, { AdminUpdateRequest } from '@/services/AdminService'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import { useRoute, useRouter } from 'vue-router'
import FormAdmin from './form-admin.vue'
import TPageTitle from '@/components/TPageTitle.vue'

const route = useRoute()
const loader = useLoader()
const snackbar = useSnackBar()
const router = useRouter()

const model = ref<AdminUpdateRequest>()

async function fetch() {
  try {
    loader.increment()
    const response = await (new AdminService()).show(route.params.id as string)
    const data = response.data.data

    model.value = {
      ...data,
      producer_ids: data.producers.map(p => p.id),
      roles: data.roles ?? [],
      abilities: data.abilities ?? [],
    }
  } catch (error) {
    snackbar.show(
      'Não foi possível buscar o usuário',
      'error',
    )

    throw error
  } finally {
    loader.decrement()
  }
}

async function submit(model: AdminUpdateRequest) {
  try {
    loader.increment()

    if (model.password === '') {
      delete model.password
    }

    await (new AdminService()).update(route.params.id as string, model)

    snackbar.show(
      'Usuário atualizado com sucesso',
      'success',
    )

    router.push({ name: 'list-admins' })
  } finally {
    loader.decrement()
  }
}

onMounted(() => fetch())
</script>
